/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type OptimizationLogEntry = {
    timestamp: string;
    level: OptimizationLogEntry.level;
    message: string;
};
export namespace OptimizationLogEntry {
    export enum level {
        DEBUG = 'debug',
        INFO = 'info',
        WARNING = 'warning',
        ERROR = 'error',
    }
}

